$(document).ready(function(e){
  console.log(
  "%cCustom JS is ready",
  "background: linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(121,9,42,1) 35%, rgba(0,212,255,1) 100%); color: #FFF; font-weight: bold; font-size: 50px;"
);


//index 3 slider

 $('.indx-3-slider').slick({
   dots: false,
   arrows:true,
   infinite: false,
   speed: 300,
   slidesToShow: 3,
   slidesToScroll: 1,
   adaptiveHeight: false,
   prevArrow: '<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0617/1921/6197/files/left-arrow.png?" alt="Previous"></button>',
   nextArrow: '<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0617/1921/6197/files/left-arrow.png?" alt="Next"></button>',
   responsive: [
     {
       breakpoint: 1199,
       settings: {
         slidesToShow: 3,
         slidesToScroll: 1
       }
     },
     {
       breakpoint: 992,
       settings: {
         slidesToShow: 3,
         slidesToScroll: 1
       }
     },
     {
       breakpoint: 768,
       settings: {
         slidesToShow: 2,
         slidesToScroll: 1
       }
     },
     {
       breakpoint: 600,
       settings: {
         slidesToShow: 1,
         slidesToScroll: 1
       }
     }
   ]
 });

  
  

//index 6 slider
var $slider = $('.indx-6-slider');
  var $progressBar = $('.progress');
  var $progressBarLabel = $( '.slider__label' );
  
  $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
    var calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;
    
    $progressBar
      .css('background-size', calc + '% 100%')
      .attr('aria-valuenow', calc );
    
    $progressBarLabel.text( calc + '% completed' );
  });
 $slider.slick({
   dots: false,
   arrows:true,
   infinite: true,
   speed: 300,
   slidesToShow: 4,
   slidesToScroll: 1,
   adaptiveHeight: false,
   responsive: [
     {
       breakpoint: 1199,
       settings: {
         slidesToShow: 4,
         slidesToScroll: 1
       }
     },
     {
       breakpoint: 992,
       settings: {
         slidesToShow: 3,
         slidesToScroll: 1
       }
     },
     {
       breakpoint: 768,
       settings: {
         slidesToShow: 2,
         slidesToScroll: 1
       }
     },
     {
       breakpoint: 600,
       settings: {
         slidesToShow: 1,
         slidesToScroll: 1
       }
     }
   ]
 });


//index 7 slider
  var $slider2 = $('.indx-7-slider');
  var $progressBar2 = $('.indx7progress');
  var $progressBarLabel2 = $( '.indx7slider__label' );
  
  $slider2.on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
    var calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;
    
    $progressBar2
      .css('background-size', calc + '% 100%')
      .attr('aria-valuenow', calc );
    
    $progressBarLabel2.text( calc + '% completed' );
  });

 $slider2.slick({
   dots: true,
   arrows:true,
   infinite: true,
   speed: 300,
   slidesToShow: 1,
   slidesToScroll: 1,
   adaptiveHeight: false,
   responsive: [
     {
       breakpoint: 1199,
       settings: {
         slidesToShow: 1,
         slidesToScroll: 1
       }
     },
     {
       breakpoint: 992,
       settings: {
         slidesToShow: 1,
         slidesToScroll: 1
       }
     },
     {
       breakpoint: 768,
       settings: {
         slidesToShow: 1,
         slidesToScroll: 1
       }
     },
     {
       breakpoint: 600,
       settings: {
         slidesToShow: 1,
         slidesToScroll: 1
       }
     }
   ]
 });


//for collection header text split and span tag add
  

// Find the element that contains the collection name
    var collectionNameElement = $('.collection-hero__title h2');

    // Get the text of the collection name and remove 'Collection:' part
    var collectionName = collectionNameElement.text().trim().replace('Collection:', '').trim();

    // Split the collection name into words
    var words = collectionName.split(" ");

    if(words.length > 1) {
        // Get the last word
        var lastWord = words.pop();

        // Join the rest of the words back together
        var firstPart = words.join(" ");

        // Update the collection name with the span tag around the last word
        collectionNameElement.html(firstPart + ' <span class="last-word">' + lastWord + '</span>');
    }


// for collection load more ajax  
  
$('.js-load-more').on('click', function(){
 var $this =$(this),
 totalPages = parseInt($('[data-all-pages]').val()),
 currentPage = parseInt($('[data-this-page]').val()),
 datacollurl = $('[data-coll-url]').val();;
 $this.attr('disabled', true);
 $this.find('[load-more-text]').addClass('hide');
 $this.find('[loader]').removeClass('hide');
 var nextUrl = $('[data-next-link]').val();
 var current_page_new = currentPage + 1;
 var next_coll = currentPage + 2;
 //alert(current_page_new)
 //return false;
 $.ajax({
 url: nextUrl,
 type: 'GET',
 dataType: 'html',
 success: function(responseHTML){
 $('[data-next-link]').val(datacollurl + "?page="+next_coll);
 $('[data-this-page]').val(current_page_new);
 $('.product-grid').append($(responseHTML).find('.product-grid').html());
 },
 complete: function() {
 if(current_page_new < totalPages) {
 $this.attr('disabled', false); $this.find('[load-more-text]').removeClass('hide'); $this.find('[loader]').addClass('hide');
 } 
 if(current_page_new >= totalPages) {
 $this.find('[load-more-text]').text('Products Finished').removeClass('hide'); $this.find('[loader]').addClass('hide');
 } 
 }
 })
});
  




    function activateLink(linkElement) {
        // Remove active class from all links
        $(".coll-menu-link").removeClass("active");

        // Add active class to the clicked link
        linkElement.addClass("active");

        // Store the active link URL in localStorage
        localStorage.setItem('activeLink', linkElement.attr('href'));
    }

    // Add click event to each link
    $(".coll-menu-link").click(function(event) {
        activateLink($(this));
    });

    // Get the current page URL
    let currentUrl = window.location.pathname;

    // Check if any menu link matches the current URL
    let activeLinkElement = $(".coll-menu-link").filter(function() {
        return $(this).attr('href') === currentUrl || currentUrl.includes($(this).attr('href'));
    });

    if (activeLinkElement.length) {
        // If a matching link is found, activate it
        activateLink(activeLinkElement);
    } else {
        // If no link matches, use the first link as a fallback
        activateLink($(".coll-menu-link").first());
    }



  

//for FAQ

  
$(function() {
$('.accordion .acc-headng-main').click(function(){
$(this).parent().toggleClass(' active ');
$(this).parent().siblings().removeClass('active');

$(this).parent().children(".content-box").toggleClass('open').slideToggle();
$(this).parent().siblings().children(".content-box").removeClass('open').slideUp();
return false;
});
});
 
  

});